module.exports = __webpack_public_path__ + "static/media/feedback_icon.405e0911.svg";